import { render, staticRenderFns } from "./TalentSearch.vue?vue&type=template&id=3fe5c632&scoped=true"
import script from "./TalentSearch.vue?vue&type=script&lang=js"
export * from "./TalentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5c632",
  null
  
)

export default component.exports